import { NavigationModal } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

type DeactivatingServiceUserModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
  backNavigation: () => void
  name: string
  status: string
}

const DeactivatingServiceUserModal = ({
  showModal,
  onCancel,
  onConfirm,
  backNavigation,
  name,
  status,
}: DeactivatingServiceUserModalProps) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <NavigationModal
      modalTitle={t('DEACTIVATE_SU_TITLE')}
      modalContentText={t('DEACTIVATE_SU_DESCRIPTION', { name, status })}
      modalConfirmText={t('OK')}
      modalCancelText={t('CANCEL')}
      showPrompt={showModal}
      confirmNavigation={handleConfirm}
      cancelNavigation={onCancel}
      confirmButtonProps={{ variant: 'primary' }}
      hasBackButton
      backButtonText={t('BACK')}
      backNavigation={backNavigation}
    >
      <Container>
        <Text>{t('DEACTIVATE_SU_MORE_INFO', { name })}</Text>
      </Container>
    </NavigationModal>
  )
}

const Container = styled.div`
  height: 116px;
`

export default DeactivatingServiceUserModal
